import { AutogenModelDrsManDeduct, AutogenRowDrsManDeduct } from "./autogen/AutogenModelDrsManDeduct";

export class ModelDrsManDeduct extends AutogenModelDrsManDeduct<RowDrsManDeduct> {
	constructor() {
		super(RowDrsManDeduct);
	}
}

export class RowDrsManDeduct extends AutogenRowDrsManDeduct {
}